import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'availableForYouHeading'
	| 'recommendedAgentsCategory'
	| 'recommendationsHeading'
	| 'recommendationsSubtitle'
	| 'jiraRecommendationsHeading'
	| 'jiraRecommendationsSubtitle'
	| 'templatesHeading'
	| 'templatesUpliftHeading'
	| 'templatesSubtitle';

export const messages: Record<
	MessageKeys,
	{ defaultMessage: string; description: string; id: string }
> = defineMessages({
	recommendedAgentsCategory: {
		id: 'agent-studio.landing.recommended-agents.category.ai-non-final',
		defaultMessage: 'Recommended',
		description: 'Label for the browse-agent category that shows recommended agents.',
	},
	availableForYouHeading: {
		id: 'agent-studio.landing.available-for-you.heading.ai-non-final',
		defaultMessage: 'Available for you',
		description:
			'Heading above the list of agents and templates recommended to the user in Atlassian Studio.',
	},
	templatesHeading: {
		id: 'agent-studio.landing.templates.heading.ai-non-final',
		defaultMessage: 'Remix a template',
		description: 'Heading above the list of templates available in Atlassian Studio.',
	},
	recommendationsHeading: {
		id: 'studio-browse-kit.browse-agent.entrypoints.recommended.recommendationsHeading',
		defaultMessage: 'Our top recommendations for you',
		description: 'Heading above the personalized agent recommendations.',
	},
	recommendationsSubtitle: {
		id: 'studio-browse-kit.browse-agent.entrypoints.recommended.recommendationsSubtitle',
		defaultMessage: 'Based on your role, usage, team and more',
		description: 'Explains how the agent recommendations are personalized.',
	},
	jiraRecommendationsHeading: {
		id: 'studio-agent-browse.browse-agent.entrypoints.recommended.jiraRecommendationsHeading',
		defaultMessage: 'Recommended agents',
		description: 'Heading above the recommended agents below Coding Agents.',
	},
	jiraRecommendationsSubtitle: {
		id: 'studio-agent-browse.browse-agent.entrypoints.recommended.jiraRecommendationsSubtitle',
		defaultMessage: 'Your closest collaborators love these agents',
		description: 'Explains that the recommended agents are popular with close collaborators.',
	},
	templatesUpliftHeading: {
		id: 'studio-browse-kit.browse-agent.entrypoints.recommended.templatesUpliftHeading',
		defaultMessage: 'Templates',
		description: 'Heading above templates in the uplifted Recommended tab.',
	},
	templatesSubtitle: {
		id: 'studio-browse-kit.browse-agent.entrypoints.recommended.templatesSubtitle',
		defaultMessage: 'Can’t find what you’re looking for? Remix a template',
		description: 'Invites users to remix a template below the Templates heading.',
	},
});
